import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * @file 列表hook
 * @author alfielv
 */
import _ from 'lodash';
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import axios from 'axios';
import useOriginReference from '../../../hooks/useOriginReference';
import message from '../../Message';
var DEFAULT_PAGESIZE = 20; // 默认pageSize 20

var CancelToken = axios.CancelToken,
    Cancel = axios.Cancel;
export default (function (props) {
  var action = props.action,
      $onRequest = props.$onRequest,
      $onResponse = props.$onResponse,
      $onError = props.$onError,
      pageBarAction = props.pageBarAction,
      $onPageBarResponse = props.$onPageBarResponse,
      defaultFilterData = props.defaultFilterData,
      customFiltersLoaded = props.customFiltersLoaded,
      tableConfig = props.tableConfig,
      _props$filterConfig = props.filterConfig,
      filterConfig = _props$filterConfig === void 0 ? {} : _props$filterConfig;

  var _ref = tableConfig || {},
      defaultPageSize = _ref.defaultPageSize,
      defaultOrderBy = _ref.defaultOrderBy,
      defaultSelectKeys = _ref.defaultSelectKeys,
      _ref$hideErrorMessage = _ref.hideErrorMessage,
      hideErrorMessage = _ref$hideErrorMessage === void 0 ? false : _ref$hideErrorMessage;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      pageNo = _useState2[0],
      setPageNo = _useState2[1];

  var _useState3 = useState(defaultPageSize || DEFAULT_PAGESIZE),
      _useState4 = _slicedToArray(_useState3, 2),
      pageSize = _useState4[0],
      setPageSize = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      tableData = _useState6[0],
      setTableData = _useState6[1]; // 表格数据


  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      pageBarData = _useState8[0],
      setPageBarData = _useState8[1]; // 表格数据


  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      loading = _useState10[0],
      setLoading = _useState10[1]; // 表格数据加载状态


  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      pageBarLoading = _useState12[0],
      setPageBarLoading = _useState12[1]; // pageBar数据加载状态


  var _useState13 = useState(defaultSelectKeys || []),
      _useState14 = _slicedToArray(_useState13, 2),
      selectKeys = _useState14[0],
      setSelectKeys = _useState14[1]; // 多选模式已选keys


  var _useState15 = useState(defaultFilterData),
      _useState16 = _slicedToArray(_useState15, 2),
      filterData = _useState16[0],
      setFilterData = _useState16[1]; // 筛选数据


  var _useState17 = useState(defaultOrderBy || ''),
      _useState18 = _slicedToArray(_useState17, 2),
      orderBy = _useState18[0],
      setOrderBy = _useState18[1]; // 排序依赖字段


  var _useState19 = useState('desc'),
      _useState20 = _slicedToArray(_useState19, 2),
      orderType = _useState20[0],
      setOrderType = _useState20[1]; // 排序类型 desc/asc


  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      batchShow = _useState22[0],
      setBatchShow = _useState22[1]; // 批量操作区显示


  var paramsRef = useRef(null);
  var pageBarParamsRef = useRef(null);
  var cancelRef = useRef(false); // 取消update state标记

  var cancelTokenRef = useRef(null); // cancel token ref

  var pageBarCancelTokenRef = useRef(null); // cancel token ref
  // 请求数据

  var fetchData = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var cancelTokenSource, requestAction, responseData, retData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 取消上次请求
              if (cancelTokenRef.current) {
                cancelTokenRef.current.cancel('INFO in ListView component: Operation canceled by new request.');
              }

              setLoading(true); // 创建本次请求cancelToken

              cancelTokenSource = CancelToken.source();
              cancelTokenRef.current = cancelTokenSource;
              requestAction = action(params, cancelTokenSource.token);
              _context.prev = 5;
              _context.next = 8;
              return requestAction;

            case 8:
              responseData = _context.sent;

              if (!cancelRef.current) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              retData = _.isFunction($onResponse) ? $onResponse.call(undefined, responseData) || responseData : responseData;
              setTableData(retData);
              setLoading(false);
              _context.next = 22;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](5);

              if (!(_context.t0 instanceof Cancel)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (_.isFunction($onError)) {
                $onError.call(undefined, _context.t0);
              }

              !hideErrorMessage && message.error(_context.t0.message);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 16]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [action, hideErrorMessage, $onResponse, $onError]); // 请求页码数据

  var fetchPageBarData = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
      var cancelTokenSource, requestAction, responseData, dataCount;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (pageBarAction) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              // 取消上次请求
              if (pageBarCancelTokenRef.current) {
                pageBarCancelTokenRef.current.cancel('INFO in ListView component: Operation of pageBar request canceled by new request.');
              }

              setPageBarLoading(true); // 创建本次请求cancelToken

              cancelTokenSource = CancelToken.source();
              pageBarCancelTokenRef.current = cancelTokenSource;
              requestAction = pageBarAction(params, cancelTokenSource.token);
              _context2.prev = 7;
              _context2.next = 10;
              return requestAction;

            case 10:
              responseData = _context2.sent;
              dataCount = _.isFunction($onPageBarResponse) ? $onPageBarResponse.call(undefined, responseData) || responseData : responseData;
              setPageBarData({
                page: pageNo,
                page_size: pageSize,
                total_number: dataCount,
                total_page: Math.ceil(dataCount / pageSize)
              });
              setPageBarLoading(false);
              _context2.next = 22;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](7);

              if (!(_context2.t0 instanceof Cancel)) {
                _context2.next = 20;
                break;
              }

              return _context2.abrupt("return");

            case 20:
              if (_.isFunction($onError)) {
                $onError.call(undefined, _context2.t0);
              }

              !hideErrorMessage && message.error(_context2.t0.message);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[7, 16]]);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [$onError, $onPageBarResponse, hideErrorMessage, pageBarAction, pageNo, pageSize]);

  var _ref4 = filterConfig || {},
      controls = _ref4.controls; // 请求参数


  var requestParams = useMemo(function () {
    // 格式化filterData
    var formatFilterData = {};

    _.forEach(_.keys(filterData), function (key) {
      // 过滤掉null、undefined、空字符串
      if (!_.isNil(filterData[key]) && filterData[key] !== '') {
        var value = filterData[key]; // key名包含'.', 组装成对象层级结构
        // 否则直接赋值

        if (_.includes(key, '.')) {
          _.set(formatFilterData, key, value);
        } else {
          var _ref5 = _.find(controls, ['name', key]) || {},
              name = _ref5.name,
              type = _ref5.type,
              _ref5$config = _ref5.config,
              config = _ref5$config === void 0 ? {} : _ref5$config;

          var _config$type = config.type,
              dateType = _config$type === void 0 ? '' : _config$type; // 时间筛选

          if (_.includes(name, ',') && type === 'date-picker' && dateType !== 'single') {
            var nameArr = name.replace(/\s*/g, '').split(',');

            if (Array.isArray(nameArr) && _.size(nameArr) > 1) {
              var startTimeKey = _.head(nameArr);

              var endTimeKey = _.last(nameArr);

              formatFilterData[startTimeKey] = value[startTimeKey];
              formatFilterData[endTimeKey] = value[endTimeKey];
            }
          } else {
            formatFilterData[key] = value;
          }
        }
      }
    });

    var params = _objectSpread(_objectSpread({}, formatFilterData), {}, {
      page: pageNo,
      page_size: pageSize
    }, orderBy && orderType ? {
      order: {
        field: orderBy,
        type: orderType.toUpperCase()
      }
    } : {});

    return _.isFunction($onRequest) ? $onRequest.call(undefined, params) || params : params;
  }, [pageNo, pageSize, orderBy, orderType, filterData, $onRequest]); // 页码配置请求参数

  var pageBarRequestParams = useMemo(function () {
    var params = _objectSpread({}, requestParams);

    delete params.page;
    return params;
  }, [requestParams]); // 比较filterData默认值，远程请求完成更新一波

  var defaultFilterDataOrigin = useOriginReference(defaultFilterData);
  useEffect(function () {
    // 筛选项加载初始与加载状态，不更新
    if (!customFiltersLoaded) {
      return;
    }

    setFilterData(defaultFilterDataOrigin);
  }, [defaultFilterDataOrigin, customFiltersLoaded]);
  useEffect(function () {
    // 筛选项加载初始与加载状态，不发起请求
    if (!customFiltersLoaded) {
      return;
    }

    if (!_.isEqual(paramsRef.current, requestParams)) {
      // 参数改变时，才发起新的请求
      paramsRef.current = requestParams;
      fetchData(requestParams);
    }
  }, [requestParams, fetchData, customFiltersLoaded]);
  useEffect(function () {
    if (!_.isEqual(pageBarParamsRef.current, pageBarRequestParams)) {
      pageBarParamsRef.current = pageBarRequestParams;
      fetchPageBarData(pageBarRequestParams);
    }
  }, [pageBarRequestParams, pageBarParamsRef, fetchPageBarData]); // clean up

  useEffect(function () {
    return function () {
      // 更新cancel state update标记
      cancelRef.current = true; // 取消未完成的请求

      if (cancelTokenRef.current) {
        cancelTokenRef.current.cancel('INFO in ListView component: Operation canceled by leave.');
      }
    };
  }, []); // 创建column列字段与表头映射

  var columnMap = useMemo(function () {
    var columns = tableConfig.columns;

    if (!columns) {
      return {};
    }

    return _.reduce(columns, function (result, current) {
      // 兼容自定义列为空的case
      if (!current) {
        return result;
      }

      var _current$name = current.name,
          name = _current$name === void 0 ? '' : _current$name,
          _current$title = current.title,
          title = _current$title === void 0 ? '' : _current$title;
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, name, title));
    }, {});
  }, [tableConfig]); // 加载list

  var loadList = useCallback(function () {
    fetchData(requestParams);
  }, [fetchData, requestParams]); // 重置请求参数

  var resetList = useCallback(function () {
    setPageNo(1);
    setFilterData({});
    setSelectKeys([]);
  }, []);
  return {
    pageNo: pageNo,
    pageSize: pageSize,
    tableData: _objectSpread(_objectSpread({}, tableData), {}, {
      page_info: _objectSpread(_objectSpread({}, tableData === null || tableData === void 0 ? void 0 : tableData.page_info), pageBarData)
    }),
    loading: loading,
    pageBarLoading: pageBarLoading,
    selectKeys: selectKeys,
    filterData: filterData,
    orderBy: orderBy,
    orderType: orderType,
    batchShow: batchShow,
    columnMap: columnMap,
    requestParams: requestParams,
    setPageNo: setPageNo,
    setPageSize: setPageSize,
    setTableData: setTableData,
    setSelectKeys: setSelectKeys,
    setFilterData: setFilterData,
    setOrderBy: setOrderBy,
    setOrderType: setOrderType,
    setBatchShow: setBatchShow,
    loadList: loadList,
    resetList: resetList
  };
});